import { render, staticRenderFns } from "./MyWidgets.vue?vue&type=template&id=79d684dc"
import script from "./MyWidgets.vue?vue&type=script&lang=js"
export * from "./MyWidgets.vue?vue&type=script&lang=js"
import style0 from "./MyWidgets.vue?vue&type=style&index=0&id=79d684dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports